export const twitterLink = "";
export const glossaryLink = "https://gdt.gradepro.org/app/handbook/handbook.html#h.buaodtl66dyx";
export const showBanner = false;
